import React from "react";
import { navigate } from "hookrouter";
import Register from "./Register";
import Login from "./Login";
import styles from "./Login.module.css";
import AuthContext from "../../contexts/AuthContext";
import Loading from "../Loading";
import Reset from "./Reset";
import ResetSend from "./ResetSend";
import Verify from "./Verify";
import { useAuth } from "./AuthHooks";

const Auth = ({ type, code }) => {
  let elem;
  switch (type) {
    case "create":
      elem = <Register />;
      break;
    case "reset":
      elem = <Reset code={code} />;
      break;
    case "resetSend":
      elem = <ResetSend />;
      break;
    case "verify":
      elem = <Verify />;
      break;
    default:
      elem = <Login />;
      break;
  }

  // const { setToken, setUser } = React.useContext(AuthContext);
  // const [loading, setLoading] = React.useState(true);
  const { loading } = useAuth();

  // React.useEffect(() => {
  //   // const token = localStorage.getItem("token");
  //   // const user = JSON.parse(localStorage.getItem("user"));
  //   // if (token && user) {
  //   //   setToken(token);
  //   //   setUser(user);
  //   //   navigate("/");
  //   //   setLoading(false);
  //   // } else {
  //   //   setLoading(false);
  //   // }
  // }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.logo}>Yazbie</div>
        {loading ? <Loading top={true} /> : elem}
      </div>
    </div>
  );
};

export default Auth;
